<template>
  <div v-loading="loading">
    <el-row class="btn-group">
      <el-button class="btn-item" type="primary" size="medium" @click="handleBtn('back')">
        {{ $t('after-sales::in-box::detail_reply') }}
      </el-button>
      <el-dropdown trigger="click" class="btn-item" @command="val => handleCommand(val, 'tag')">
        <el-button type="default" size="medium">
          {{ $t('after-sales::in-box::detail_mark_as') }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu :appendToBody="false" slot="dropdown">
          <el-dropdown-item :command="item.value" v-for="(item, i) in tagDtolist" :key="i">
            <span
              :style="
                `margin-right:4px;border-radius: 2px;display:inline-block;width:10px;height: 8px;vertical-align: middle;background: ${item.color}`
              "
            ></span>
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" class="btn-item" @command="val => handleCommand(val, 'type')">
        <el-button type="default" size="medium">
          {{ $t('after-sales::in-box::detail_classify') }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu :appendToBody="false" slot="dropdown">
          <el-dropdown-item :command="item.value" v-for="(item, i) in types" :key="i">
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-row>
    <el-row class="box-wrap" :gutter="10">
      <el-col :span="24" class="title desc-item">
        <span class="oneline title-info" :title="form.subject">
          {{ form.subject }}
        </span>
        <p>
          <el-tag
            v-for="tag in form.tagDtolist"
            :key="tag.id"
            closable
            @close="handleCloseTag(form, tag.id)"
            :style="
              `background-color:${tag.color};
              border-color: ${tag.color};
              color: #fff;margin-right: 4px;margin-bottom: 4px;`
            "
          >
            {{ tag.parentName ? `${tag.parentName}- ${tag.name}` : tag.name }}
          </el-tag>
        </p>
      </el-col>
      <el-col :lg="6" :md="8" class=" desc-item">
        <span class="label">{{ $t('after-sales::in-box::detail_email_id') }}：</span>
        <span class="value">{{ $dataCheck(form.id) }}</span>
      </el-col>
      <el-col :lg="6" :md="8" class=" desc-item">
        <span class="label">{{ $t('after-sales::in-box::detail_recipient') }}：</span>
        <span class="value">{{ $dataCheck(form.to) }}</span>
      </el-col>
      <el-col :lg="6" :md="8" class="desc-item">
        <span class="label">{{ $t('after-sales::in-box::detail_sender') }}：</span>
        <span class="value">{{ $dataCheck(form.from) }}</span>
      </el-col>
      <el-col :lg="6" :md="8" class=" desc-item">
        <span class="label">{{ $t('after-sales::in-box::detail_handler') }}：</span>
        <span class="value">{{ $dataCheck(form.staffName) }}</span>
      </el-col>
      <el-col :lg="6" :md="8" class=" desc-item">
        <span class="label">{{ $t('after-sales::in-box::detail_sort') }}：</span>
        <span class="value">{{ $dataCheck(form.categoryName) }}</span>
      </el-col>
      <el-col :lg="6" :md="8" class=" desc-item">
        <span class="label">{{ $t('after-sales::in-box::detail_status') }}：</span>
        <span class="value">
          {{
            $dataCheck(
              {
                0: $t('after-sales::in-box::status_未回复'),
                1: $t('after-sales::in-box::status_回复'),
                2: $t('after-sales::in-box::status_超时未回复')
              }[form.status]
            )
          }}
        </span>
      </el-col>
      <el-col :lg="6" :md="8" class=" desc-item">
        <span class="label">{{ $t('after-sales::in-box::detail_reply_time') }}：</span>
        <span class="value">{{ $dataCheck(form.latestReplyTime) }}</span>
      </el-col>
      <el-col :lg="6" :md="8" class="desc-item">
        <span class="label">{{ $t('after-sales::in-box::detail_replier') }}：</span>
        <span class="value">{{ $dataCheck(form.latestReplyPersonName) }}</span>
      </el-col>
      <el-col :lg="6" :md="8" class=" desc-item">
        <span class="label">{{ $t('after-sales::in-box::detail_send_time') }}：</span>
        <span class="value">{{ $dataCheck(form.sentDate) }}</span>
      </el-col>
    </el-row>
    <el-row class="remark-info">
      <el-form ref="form" :model="form" label-width="60px">
        <el-form-item :label="t('after-sales::in-box::detail_remark')">
          <div class="txt-box">
            <el-input
              type="textarea"
              @blur="handleSaveRemark"
              :autosize="{ minRows: 4, maxRows: 10 }"
              v-model="form.remark"
              :placeholder="t('after-sales::in-box::detail_remark_placeholder')"
            ></el-input>
            <el-button type="default" class="loading-save" :loading="remarkLoading"></el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row class="content-box">
      <!-- <el-col>{{ form.content }}</el-col> -->
      <RichEditor v-model="form.content" :initData="reInit" placeholder="请输入正文" />
    </el-row>
    <el-button class="footer-copy" @click="$copy(form.content)" type="primary">
      {{ t('after-sales::in-box::detail_copy_content') }}
    </el-button>
    <drawerEmail v-model="drawerVisable" :drawRow="drawRow"></drawerEmail>
  </div>
</template>
<script>
import moment from 'moment'
import drawerEmail from '../components/write-email'
import RichEditor from '@/components/rich-editor'
import {
  getEmailDetail,
  updateEmailListItemTag,
  updateEmailListItemType,
  putEmailRemark
} from '@/server/after-sales.js'
import { getDicByCode, putMerchantConfig } from '@/server/common'
export default {
  name: 'detailInfo',
  components: {
    drawerEmail,
    RichEditor
  },
  props: {
    params: {
      default: () => {}
    }
  },
  data() {
    return {
      reInit: {
        language: 'zh_CN',
        height: 500,
        menubar: false,
        branding: false,
        statusbar: false,
        placeholder: this.placeholder,
        // toolbar: false,
        // menubar: 'file edit insert view format table tools help',
        plugins: [],
        paste_data_images: true,
        toolbar: ''
      },
      drawerVisable: false,
      tagDtolist: [],
      types: [],
      drawRow: {
        type: 'write',
        item: {}
      },
      dataInfo: {},
      remarkLoading: false,
      form: {
        remark: '',
        content:
          "<div style='font-weight:600;'>The following message to was undeliverable. The reason for the problem: 5.1.0 - Unknown address error 553-'Inactive user coraletzioni'</div>"
      },

      tableData: [],

      loading: false,
      noMore: false
    }
  },

  mounted() {
    this.initDictData()
    this.getEmailInfo()
  },

  methods: {
    t(key) {
      return this.$t(key)
    },
    async initDictData() {
      this.loading = true
      const [tags, type] = await Promise.all([putMerchantConfig(2), getDicByCode(5)])
      if (tags.data.code === 0) {
        const list = []
        tags.data.data.forEach(item => {
          if (item.childrens.length) {
            item.childrens.forEach(im => {
              list.push({ label: `${im.parentName}-${im.name}`, value: im.id, color: im.color })
            })
          } else {
            list.push({ label: `${item.name}`, value: item.id, color: item.color })
          }
        })
        this.tagDtolist = list
      }
      if (type.data.code === 0) {
        this.types = type.data.data.map(i => ({
          label: this.$t(`system::email::category::${i.name}`, i.name),
          value: i.id
        }))
      }
      this.loading = false
    },
    async getEmailInfo() {
      this.loading = true
      let params = { id: this.params.emailId, type: this.params.type }
      if (this.params.changeEmailId) {
        params = { id: this.params.changeEmailId, type: this.params.changeType }
      }
      const { data } = await getEmailDetail(params)
      this.loading = false
      if (data.code === this.$code) {
        this.form = {
          ...this.form,
          ...data.data
        }
        this.form.content = this.form.content.replace(/\/n|\/r/g, '')
      }
    },
    handleBtn(type) {
      this.drawRow.type = type
      this.drawRow.item = this.form
      this.drawerVisable = true
    },
    async handleCloseTag(row, id) {
      this.loading = true
      const { data } = await updateEmailListItemTag({
        ids: String(row.id),
        tagIds: row.tagDtolist
          .map(item => item.id)
          .filter(item => item !== id)
          .join(',')
      })

      this.loading = false
      if (data.code === this.$code) {
        row.tagDtolist = row.tagDtolist.filter(item => item.id !== id)
        this.$message.success(this.$t('system::tip::delete_success'))
      }
    },
    async handleCommand(val, about) {
      let res = {}
      this.loading = true
      if (about === 'tag') {
        const { data } = await updateEmailListItemTag({
          ids: this.params.changeEmailId ? String(this.params.changeEmailId) : String(this.params.emailId),
          isAdd: 1,
          tagIds: String(val)
          // tagIds: String(val) + ',' + this.form.tagDtolist.map(item => item.id).join(',')
        })
        res = data
      } else if (about === 'type') {
        const { data } = await updateEmailListItemType({
          ids: this.params.changeEmailId ? String(this.params.changeEmailId) : String(this.params.emailId),
          categoryId: val
        })
        res = data
      }
      if (res.code === this.$code) {
        this.$message.success(this.$t('system::tip::control_success'))
        this.getEmailInfo()
      }
      this.loading = false
    },
    async handleSaveRemark(remark) {
      this.remarkLoading = true
      const { data } = await putEmailRemark({ id: Number(this.params.emailId), remark: remark.target.value })
      this.remarkLoading = false
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::control_success'))
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-group {
  .btn-item {
    margin-left: 0;
    margin-right: 10px;
  }
}
.box-wrap {
  margin-top: 16px;
  .title {
    font-weight: bold;
    .title-info {
      margin-bottom: 10px;
      padding-right: 10px;
    }
  }
}
.desc-item {
  line-height: 24px;
  margin-bottom: 12px;
  .label {
    margin-right: 0px;
  }
  .value {
    color: #5d6494;
  }
}
.oneline {
  overflow: hidden;
  vertical-align: middle;
  max-width: 480px;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.remark-info {
  margin-top: 16px;
  border-bottom: 1px solid #ebeef5;
}
.txt-box {
  max-width: 600px;
  position: relative;
  .loading-save {
    padding-left: 0px;
    position: absolute;
    bottom: -12px;
    right: -45px;
    border: none;
  }
}

::v-deep {
  .el-form-item {
    .el-form-item__label {
      line-height: 1;
    }
  }
  .el-tag__close {
    color: #fff;
    &:hover {
      background-color: inherit;
    }
  }
}

.content-box {
  padding: 24px 0;
  min-height: 300px;
}
</style>
